


























import { defineComponent, useRoute, ref, useContext } from '@nuxtjs/composition-api';
import { Search } from '@/compositions/base-search';

export default defineComponent({
  name: 'NewsDetail',
  setup() {
    const apiSearch = '/api/v1/news/search';
    const { setSearchConfig, loadData, item } = Search();
    const route = useRoute();
    const id = parseInt(route.value.params.id);
    const loaded = ref<boolean>(false);

    setSearchConfig(apiSearch, { onlyOne: true, doToast: false });
    const ctx = useContext();

    // データ取得API実行
    loadData({ conditions: { news_id: id } }).then((data:any) => {
      if (data.list.length === 0) {
        ctx.error({ statusCode: 404, message: '指定されたデータが存在しませんでした。' });
      }
      loaded.value = true;
    });

    return {
      item,
      loaded
    };
  }
});
